import { render, staticRenderFns } from "./TableWithOutPagination.vue?vue&type=template&id=706ddad2&scoped=true"
import script from "./TableWithOutPagination.vue?vue&type=script&lang=js"
export * from "./TableWithOutPagination.vue?vue&type=script&lang=js"
import style0 from "./TableWithOutPagination.vue?vue&type=style&index=0&id=706ddad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0__lodash@4._babb32925cd4b8a8c1892c895ee75fdf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ddad2",
  null
  
)

export default component.exports